import {
    Component,
    InputSignal,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    input,
    signal,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { IqTrendlinesFuelStateService } from '../state';
import {} from '@angular/common/http';

@Component({
    selector: 'iq-trendlines-fuel-card',
    standalone: true,
    imports: [CommonModule, NgOptimizedImage],
    templateUrl: './iq-trendlines-fuel-card.component.html',
    styleUrl: './iq-trendlines-fuel-card.component.scss',
})
export class IqTrendlinesFuelCardComponent implements OnInit {
    id: InputSignal<string> = input('');
    testId: InputSignal<string> = input('');

    currentTestId: Signal<string> = computed(() => {
        return this.testId()?.length ? this.testId() : this.id();
    });

    data: Signal<{ perGallon: string; percentChange: string }> = computed(
        () => {
            return {
                perGallon: this.cost(),
                percentChange: this.percentChange(),
            };
        },
    );

    costSignal: Signal<string> = signal('--');
    cost: Signal<string> = computed((): string => {
        return this.costSignal();
    });

    // Call this in the OnInit Function
    private _setCostSignal(): void {
        this.costSignal = this._state.cost();
    }

    percentChangeSignal: Signal<string> = signal('--');
    percentChange: Signal<string> = computed((): string => {
        return this.percentChangeSignal();
    });

    // Call this in the OnInit Function
    private _setPercentChangeSignal(): void {
        this.percentChangeSignal = this._state.percentChange();
    }

    constructor(private readonly _state: IqTrendlinesFuelStateService) {}

    ngOnInit(): void {
        this._setCostSignal();
        this._setPercentChangeSignal();
    }
}
